import React from 'react';

const FrontPageRunToGoal = () => {
    return (
        <div className="goal-intro">
            {/* Ocultamos la cancha y ponemos un fondo oscuro para resaltar el logo */}
            <div className="goal-intro__logo-container">
                <div className='d-flex'>
                    <img src="/img/page/adsl-five.png" className="LogoADSLxZtudia" alt="Logo" style={{ maxWidth: '600px', width: '600px' }} />
                </div>
                <p className="goal-intro__text text-uppercase fw-bold">Presentan</p>
                <p className="goal-intro__title text-uppercase fw-bold">Tiro a la canasta</p>
            </div>

            {/* El balón que cae del cielo y rebota */}
            <img src="/img/games/runtogoal/balon-grande.png" className="goal-intro__ball" alt="Balón" />

            <p className='FooterCredits' style={{ position: 'fixed', bottom: '0', left: '50%', transform: 'translateX(-50%)', fontSize: '30px' }}>Hecho con ♥ por Five Digital Minds | 2026</p>
        </div>
    );
};

export { FrontPageRunToGoal };